import ApproverGroupApi from "../generated/api/ApproverGroupApi";

class ApproverGroupService {
  constructor() {
    this.ApproverGroupApi = new ApproverGroupApi();
  }

  async All() {
    return await window.$A.HandleApiResponse(
      this.ApproverGroupApi.getAll()
    );
  }

  async Save(group) {
    let obj = {
      name: group.name,
      approverIds: group.approverIds || [],
    };

    if (group.id !== undefined && group.id > 0) {
      return await window.$A.HandleApiResponse(
        this.ApproverGroupApi.updateApproverGroup(group.id, {
          saveApproverGroupRequest: obj,
        }),
        "Group Saved"
      );
    } else {
      return await window.$A.HandleApiResponse(
        this.ApproverGroupApi.createApproverGroup({
          saveApproverGroupRequest: obj,
        }),
        "Group Created"
      );
    }
  }

  async Delete(id) {
    return await window.$A.HandleApiResponse(
      this.ApproverGroupApi.deleteApproverGroup(id),
      "Group Deleted"
    );
  }
}

export default ApproverGroupService;
